// extracted by css-extract-rspack-plugin
export default {"root":"LJ0DpMdaLDclpfpt","spin":"Ny5_XSSr6rsrOsOO"};